import AppConfig from './services/appConfig';
import NavMenu from './components/navMenu';
import './App.css';

function App() {
	const config = AppConfig();
	// console.log( 'process.env.REACT_APP_NOT_SECRET_CODE ::', process.env.REACT_APP_NOT_SECRET_CODE );
	if ( 'object' === typeof config ) {
		return (
			<div className="App" style={{width: '100%'}}>
				<NavMenu />
			</div>
		)
	} else {
		return (
			<div className="App">
				<div style={{ height: 200, width: '100%' }}>No config object found.</div>
			</div>
		)
		
	}
}

export default App;
